import { getIntl } from '../../platform/localization'

export const getMessages = () => ({
  // these messages is used outside of react components, please make sure it has id
  errorMessageFailedSend: getIntl().formatMessage({
    id: 'errorMessageFailedSend',
    defaultMessage: 'Message failed to send, please try lofting again.',
    description: 'Text error message about failed to send message',
  }),
  errorMessageSendRetriesExhausted: getIntl().formatMessage({
    id: 'errorMessageSendRetriesExhausted',
    defaultMessage: 'Send failure, please try again later.',
    description: 'Text error message when all send retries have failed',
  }),
  errorMessageAuthChallenge: getIntl().formatMessage({
    id: 'errorMessageAuthChallenge',
    defaultMessage:
      'Your organization requires you to sign in to Microsoft again. Please reopen Salesloft from the sidebar, then try lofting again.',
    description:
      'Text error message when Microsoft requires the user to re-authenticate before the add-in can read or send their mail',
  }),
  errorMessageEmailReadyForLofting: getIntl().formatMessage({
    id: 'errorMessageEmailReadyForLofting',
    defaultMessage: 'Email is ready for lofting, please press Send.',
    description: 'Text error message for lofting email',
  }),
  errorMessageRecurrenceNotSupported: getIntl().formatMessage({
    id: 'errorMessageRecurrenceNotSupported',
    defaultMessage: 'Recurrence is not supported.',
    description: 'Text error message for lofting email',
  }),
  errorMessageSignIn: getIntl().formatMessage({
    id: 'errorMessageSignIn',
    defaultMessage: 'Please sign into Salesloft in the sidebar.',
    description: 'Text error message for sign in to Salesloft',
  }),
  errorMessageRecipientInvalid: getIntl().formatMessage({
    id: 'errorMessageRecipientInvalid',
    defaultMessage: 'Please enter recipient.',
    description: 'Text error message if recipient invalid',
  }),
  errorMessageAttendeesInvalid: getIntl().formatMessage({
    id: 'errorMessageRecipientInvalid',
    defaultMessage: 'Please enter attendees.',
    description: 'Text error message if recipient invalid',
  }),
  errorMessageEmailContactRestrictions: getIntl().formatMessage({
    id: 'errorMessageEmailContactRestrictions',
    defaultMessage: 'Recipients are either marked DNC or have email contact restrictions',
    description: 'Text error message if having email contact restrictions',
  }),
  errorMessageNoPermissionToCreatePerson: getIntl().formatMessage({
    id: 'errorMessageNoPermissionToCreatePerson',
    defaultMessage:
      'You do not have permission to create new people while lofting. Please contact your admin.',
    description: 'Text error message when user lacks permission to create person during lofting',
  }),
  errorMessageEmailInTrackingExclusionList: getIntl().formatMessage({
    id: 'errorMessageEmailInTrackingExclusionList',
    defaultMessage:
      'Email domain is on your tracking exclusion list. Emails cannot be lofted to this person.',
    description: 'Text error message if email in tracking exclusion list',
  }),
  errorMessageConnectionError: getIntl().formatMessage({
    id: 'errorMessageConnectionError',
    defaultMessage: 'Connection error occurred while trying to save the item on the server.',
    description: 'Text error message if connection error occurred',
  }),
  textLoftMessageLoftingInProgress: getIntl().formatMessage({
    id: 'textLoftMessageLoftingInProgress',
    defaultMessage: 'Lofting in progress...',
    description: 'Text loft message if lofting in progress',
  }),
  textLoftMessagePreparingMessage: getIntl().formatMessage({
    id: 'textLoftMessagePreparingMessage',
    defaultMessage: 'Preparing message...',
    description: 'Text loft message at preparing message',
  }),
  textLoftMessageConnectingToServer: getIntl().formatMessage({
    id: 'textLoftMessageConnectingToServer',
    defaultMessage: 'Connecting to server...',
    description: 'Text loft message at connecting to server',
  }),
  textLoftMessageConnectingToSalesloft: getIntl().formatMessage({
    id: 'textLoftMessageConnectingToSalesloft',
    defaultMessage: 'Connecting to Salesloft...',
    description: 'Text loft message at connecting to Salesloft',
  }),
  textLoftMessageSendingMessage: getIntl().formatMessage({
    id: 'textLoftMessageSendingMessage',
    defaultMessage: 'Sending message...',
    description: 'Text loft message at sending message',
  }),
  textLoftMessage: getIntl().formatMessage({
    id: 'textLoftMessage',
    defaultMessage: 'Your message has been Lofted. Please close this window.',
    description: 'Text loft message if message has been lofted',
  }),
  textAppointmentLoftMessage: getIntl().formatMessage({
    id: 'textAppointmentLoftMessage',
    defaultMessage: 'Your message has been Lofted. Please send the Outlook event.',
    description: 'Text loft message if message has been lofted',
  }),
})
